__turbopack_context__.v({
  "Checkbox": "fy6s3W_Checkbox",
  "Icon": "fy6s3W_Icon",
  "Indicator": "fy6s3W_Indicator",
  "Label": "fy6s3W_Label",
  "block": "fy6s3W_block",
  "body": "fy6s3W_body",
  "col": "fy6s3W_col",
  "contactSupportLink": "fy6s3W_contactSupportLink",
  "cta": "fy6s3W_cta",
  "ctaBlock": "fy6s3W_ctaBlock",
  "ctaIcon": "fy6s3W_ctaIcon",
  "ctaLink": "fy6s3W_ctaLink",
  "desc": "fy6s3W_desc",
  "divider": "fy6s3W_divider",
  "fundAvatar": "fy6s3W_fundAvatar",
  "fundDetails": "fy6s3W_fundDetails",
  "fundInfo": "fy6s3W_fundInfo",
  "fundInfoBox": "fy6s3W_fundInfoBox",
  "fundName": "fy6s3W_fundName",
  "infoContent": "fy6s3W_infoContent",
  "infoIcon": "fy6s3W_infoIcon",
  "infoLink": "fy6s3W_infoLink",
  "infoSection": "fy6s3W_infoSection",
  "infoSectionContent": "fy6s3W_infoSectionContent",
  "infoSectionLabel": "fy6s3W_infoSectionLabel",
  "infoText": "fy6s3W_infoText",
  "infoTitle": "fy6s3W_infoTitle",
  "link": "fy6s3W_link",
  "linkIcon": "fy6s3W_linkIcon",
  "needsFill": "fy6s3W_needsFill",
  "needsFillTick": "fy6s3W_needsFillTick",
  "noAccessActionText": "fy6s3W_noAccessActionText",
  "noAccessActions": "fy6s3W_noAccessActions",
  "noAccessContent": "fy6s3W_noAccessContent",
  "noAccessDescription": "fy6s3W_noAccessDescription",
  "noAccessIcon": "fy6s3W_noAccessIcon",
  "noAccessInfoBox": "fy6s3W_noAccessInfoBox",
  "noAccessTitle": "fy6s3W_noAccessTitle",
  "optImg": "fy6s3W_optImg",
  "primary": "fy6s3W_primary",
  "removeButton": "fy6s3W_removeButton",
  "row": "fy6s3W_row",
  "secondaryLabel": "fy6s3W_secondaryLabel",
  "sectionHeader": "fy6s3W_sectionHeader",
  "switchDesc": "fy6s3W_switchDesc",
  "teamLogo": "fy6s3W_teamLogo",
  "teamOption": "fy6s3W_teamOption",
});
